// extracted by mini-css-extract-plugin
export var error = "formErrors-module--error--158b0";
export var inverse = "formErrors-module--inverse--35439";
export var text = "formErrors-module--text--2661f";